import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectCardIdToDelete } from '../selectors/cards.selectors';
import { patchDeleteCard } from '../services/patchDeleteCard.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const deleteCard = createAsyncThunk(
  'cards/deleteCard',
  async (_, { getState }) => {
    const selectedCardIdToDelete = selectCardIdToDelete(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const response = await patchDeleteCard(
      selectedCardIdToDelete,
      activeEmployerInfo
    );

    return response;
  }
);
